import React from 'react';
import styled from 'styled-components';
//
import ExtendedForm from './ExtendedForm';
import OpenNoNeedRadioButton from '../OpenNoNeedRadioButton';
import BasicFormData from '../BasicFormData';
import SendEmail from '../SendEmail';
import FixaceForm from '../FixaceForm';
import SplatnostForm from '../SplatnostForm';
import CerpaniForm from '../CerpaniForm/CerpaniForm';

const propTypes = {};

class LoansForm extends React.Component {
  state = {
    name: '',
    ico: '',
    jednotka: '',
    vyseuveru: '',
    splatka: '',
    prijem: '',
    open: 'ano',
    tel: '',
    email: '',
    ucelUveru: '',
    threeYears: false,
    fiveYears: false,
    tenYears: false,
    fiveteenYears: false,
    jine: false,
    year5: false,
    year10: false,
    year15: false,
    year20: false,
    year25: false,
    fondOprav: false,
    mesicniSplatky: false,
    six: false,
    nine: false,
    twelve: false,
    eighteen: false,
    twentyfour: false,
    noIdea: false,
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleChecked = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const {
      name,
      ico,
      jednotka,
      vyseuveru,
      splatka,
      prijem,
      open,
      tel,
      ucelUveru,
      email,
      threeYears,
      fiveYears,
      tenYears,
      fiveteenYears,
      jine,
      year5,
      year10,
      year15,
      year20,
      year25,
      fondOprav,
      mesicniSplatky,
      six,
      nine,
      twelve,
      eighteen,
      twentyfour,
      noIdea,
    } = this.state;

    const data = {
      jmeno: name,
      ico,
      jednotka,
      vyseuveru,
      splatka,
      prijem,
      tel,
      email,
      ucelUveru,
      delkaFixace: {
        threeYears,
        fiveYears,
        tenYears,
        fiveteenYears,
        jine,
      },
      splatnostUveru: {
        year5,
        year10,
        year15,
        year20,
        year25,
        fondOprav,
        mesicniSplatky,
      },
      obdobiCerpani: {
        six,
        nine,
        twelve,
        eighteen,
        twentyfour,
        noIdea,
      },
    };

    return (
      <PageContainer>
        <h1>Schůzka k úvěru</h1>
        <Form>
          <form noValidate autoComplete='off'>
            <BasicFormData
              ico={ico}
              jednotka={jednotka}
              name={name}
              tel={tel}
              email={email}
              onChange={this.handleChange}
            />
            <OpenNoNeedRadioButton open={open} onOpenNoNeed={this.handleChange('open')} />
            {open === 'ano' && (
              <React.Fragment>
                <ExtendedForm
                  vyseuveru={vyseuveru}
                  splatka={splatka}
                  prijem={prijem}
                  onChange={this.handleChange}
                  ucelUveru={ucelUveru}
                />
                <FixaceForm
                  fiveYears={fiveYears}
                  tenYears={tenYears}
                  fiveteenYears={fiveteenYears}
                  threeYears={threeYears}
                  jine={jine}
                  onChecked={this.handleChecked}
                  title='Požadovaná délka fixace úrokové sazby:'
                />
                <CerpaniForm
                  onChecked={this.handleChecked}
                  six={six}
                  nine={nine}
                  twelve={twelve}
                  eighteen={eighteen}
                  twentyfour={twentyfour}
                  noIdea={noIdea}
                />
                <SplatnostForm
                  year5={year5}
                  year10={year10}
                  year15={year15}
                  year20={year20}
                  year25={year25}
                  fondOprav={fondOprav}
                  mesicniSplatky={mesicniSplatky}
                  onChecked={this.handleChecked}
                />
              </React.Fragment>
            )}
            <SendEmail
              data={data}
              disabled={(name && ico && jednotka && tel && email).length < 1}
              template='uvery_form'
            />
          </form>
        </Form>
      </PageContainer>
    );
  }
}

LoansForm.propTypes = propTypes;

export default LoansForm;

const Form = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;
const PageContainer = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
  h1 {
    margin-bottom: 12px;
  }
  @media (max-width: 450px) {
    padding: 24px 2%;
  }
`;
